var _topics = {};

export default class Topic {
  static subscribe(topicName, listener){
    var topic= Topic.findOrInitializeByName(topicName);
    var index = topic.pushListener(listener);

    return {
      remove: function(){
        topic.removeListener(index);
      }
    };
  }

  static subscribeOnce(topicName, listener){
    var subscription;

    var callback = function(data){
      listener(data);
      subscription.remove();
    };

    subscription = this.subscribe(topicName, callback);

    return subscription;
  }

  static removeAll(option){
    if(option && option.IWillUseThisFunctionOnlyForDev){
      _topics = {};
    }else{
      var msg = "\n      Please make sure that you are not using this outside of testing.\n      To disable this alert and error, please pass in an object with\n      `IWillUseThisFunctionOnlyForDev` to the `removeAll` method.\n    ";
      window.alert(msg);
      _topics = {};
    }
  }

  static publish(topicName, data){
    var topic = Topic.findOrInitializeByName(topicName);
    topic.triggerListeners(data);
  }

  static findOrInitializeByName(name){
    if(!_topics[name]){
      let topic = new Topic(name);
      _topics[name] = topic;
    }

    return _topics[name];
  }

  constructor(name){
    this._name = name;
    this._listeners = [];
  }

  listeners(){
    return this._listeners;
  }

  name(){
    return this._name;
  }

  pushListener(listener){
    return this.listeners().push(listener) - 1;
  }

  removeListener(index){
    delete this.listeners()[index];
  }

  triggerListeners(data){
    for(let index in this.listeners()){
      let listener = this.listeners()[index];
      listener(data || {});
    }
  }

  static _all(){
    return _topics;
  }
}

